import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'

/** 分组信息 */
export interface IGroupItem {
  /** 分组 ID */
  id: number;
  /** 分组名称 */
  name: string;
  /** 分组描述 */
  description?: string;
  /** 员工数 */
  staffCount: number;
}

/** 分组分页查询 */
export const fetchGroupList = async (params: {
  pageNo: number;
  pageSize: number;
  keyword?: string;
}) => {
  try {
    const data = await request.get<{ result: IGroupItem[]; totalCount: number }>(
      `${HOSTS.BASE}/api/entweb/group/search`,
      { params }
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}

/** 创建分组接口冲突项 */
export interface IGroupConflictItem {
  name: string;
  parentId: number;
  existingId?: number;
}

/** 创建分组接口响应体（原返回 Boolean，现返回对象） */
export interface ICreateGroupResult {
  /** 冲突列表：空数组表示无冲突已创建成功；非空表示存在重名冲突未创建 */
  conflictList: IGroupConflictItem[];
}

/** 创建分组（支持批量，入参为 list） */
export const createGroup = async (params: {
  groupCreateList: { name: string; description?: string }[];
}) => {
  try {
    const data = await request.post<ICreateGroupResult>(
      `${HOSTS.BASE}/api/entweb/group/create`,
      params
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}

/** 编辑分组 */
export const updateGroup = async (params: {
  groupId: number;
  name: string;
  description?: string;
}) => {
  try {
    const data = await request.post(
      `${HOSTS.BASE}/api/entweb/group/update`,
      params
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}

/** 删除分组 */
export const deleteGroup = async (params: {
  groupId: number;
}) => {
  try {
    const data = await request.post(
      `${HOSTS.BASE}/api/entweb/group/delete`,
      params
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}
